import { createSlice } from "@reduxjs/toolkit";

import {
  getDepositQueue,
  getDepositHistory,
  getUserDepositHistory,
  repeatDepositCallback,
  getDepositMedia,
  getDepositHistoryMedia,
} from "../thunks/Deposit";

const depositSlice = createSlice({
  name: "deposits",
  initialState: {
    deposits: [],
    loading: false,
    error: null,
    isLoading: false,
    depositMedia: null,
    mediaLoading: false,
    depositHistoryMedia: null,
    historyMediaLoading: false,
  },
  reducers: {
    clearDepositMedia: (state) => {
      state.depositMedia = null;
      state.mediaLoading = false;
    },
    clearDepositHistoryMedia: (state) => {
      state.depositHistoryMedia = null;
      state.historyMediaLoading = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getDepositQueue.pending, (state) => {
        state.error = null;
        state.isLoading = true;
      })
      .addCase(getDepositQueue.fulfilled, (state, action) => {
        state.deposits = action.payload;
        state.isLoading = false;
      })
      .addCase(getDepositQueue.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      });

    builder
      .addCase(getDepositHistory.pending, (state) => {
        state.error = null;
        state.isLoading = true;
      })
      .addCase(getDepositHistory.fulfilled, (state, action) => {
        state.deposits = action.payload;
        state.isLoading = false;
      })
      .addCase(getDepositHistory.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      });

    builder.addCase(getUserDepositHistory.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(getUserDepositHistory.fulfilled, (state, action) => {
      state.deposits = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUserDepositHistory.rejected, (state, action) => {
      state.error = action.error.message;
      state.isLoading = false;
    });

    builder.addCase(repeatDepositCallback.pending, (state) => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(repeatDepositCallback.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(repeatDepositCallback.rejected, (state, action) => {
      state.error = action.error.message;
      state.isLoading = false;
    });

    builder
      .addCase(getDepositMedia.pending, (state) => {
        state.error = null;
        state.mediaLoading = true;
      })
      .addCase(getDepositMedia.fulfilled, (state, action) => {
        state.depositMedia = action.payload;
        state.mediaLoading = false;
      })
      .addCase(getDepositMedia.rejected, (state, action) => {
        state.error = action.error.message;
        state.mediaLoading = false;
      });

    builder
      .addCase(getDepositHistoryMedia.pending, (state) => {
        state.error = null;
        state.historyMediaLoading = true;
      })
      .addCase(getDepositHistoryMedia.fulfilled, (state, action) => {
        state.depositHistoryMedia = action.payload;
        state.historyMediaLoading = false;
      })
      .addCase(getDepositHistoryMedia.rejected, (state, action) => {
        state.error = action.error.message;
        state.historyMediaLoading = false;
      });
  },
});

export const { clearDepositMedia, clearDepositHistoryMedia } =
  depositSlice.actions;
export const depositReducer = depositSlice.reducer;
